import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//action
import {
  getRechargeRewards,
  deleteRechargeReward,
} from "../../store/rechargeReward/action";

//routing
import { Link } from "react-router-dom";
//MUI
import {
  TablePagination,
  Tooltip,
  Menu,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import AddIcon from "@material-ui/icons/Add";
// type
import { OPEN_RECHARGE_REWARD_DIALOG } from "../../store/rechargeReward/types";

// dialog
import RechargeRewardDialog from "../dialog/RechargeRewardDialog";

//sweet alert
import { alert, warningv2 } from "../../util/Alert";

const TablePaginationActions = React.lazy(() => import("./TablePagination"));

const LevelRewards = (props) => {
  const reward = props.data;
  const [rewardImage, setRewardImage] = useState("");
  const [rewardQuantity, setRewardQuantity] = useState(0);
  const [rewardValidity, setRewardValidity] = useState(0);
  const [rewardValidityType, setRewardValidityType] = useState("");
  const [rewardName, setRewardName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const rewardType = props.data.type;

  useEffect(() => {
    if (rewardType === "diamond") {
      setRewardImage(
        "https://appadmin.vibelynk.com/static/media/diamond.1438dc3af4623cb33ddc.png",
      );
    } else if (rewardType === "avatarFrame") {
      setRewardImage(
        reward.avatarFrame.imagePreview
          ? reward.avatarFrame.imagePreview
          : reward.avatarFrame.image,
      );
    } else if (rewardType === "background") {
      setRewardImage(reward.background.image);
    } else if (rewardType === "entranceEffect") {
      setRewardImage(reward.entranceEffect.imagePreview);
    } else if (rewardType === "gift") {
      setRewardImage(reward.gift.imagePreview);
    }

    setRewardValidity(reward.validity);
    setRewardQuantity(reward.quantity);
    setRewardName(reward.name);
    setRewardValidityType(reward.validityType);
  }, [reward]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    handleMenuClose();
    props.handleDelete();
  };

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center gap-1"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={{ position: "relative", display: "inline-block" }}>
        <img
          src={rewardImage}
          alt={rewardName}
          height="45px"
          width="auto"
          style={{
            filter: isHovered ? "brightness(0.7)" : "none",
            transition: "filter 0.2s ease",
          }}
        />
        {isHovered && (
          <IconButton
            onClick={handleMenuOpen}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              padding: "4px",
            }}
            size="small"
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        )}
      </div>
      {rewardType === "diamond" ? (
        <span>x{rewardQuantity}</span>
      ) : rewardType === "gift" ? (
        <span>x{rewardQuantity} </span>
      ) : (
        <span>
          {rewardQuantity * rewardValidity}
          {rewardValidityType ? rewardValidityType.slice(0, 1) : ""}
        </span>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            backgroundColor: "#2d3748",
            color: "white",
            border: "1px solid #4a5568",
          },
        }}
        MenuListProps={{
          style: {
            backgroundColor: "#2d3748",
          },
        }}
      >
        <MenuItem
          onClick={handleDelete}
          style={{
            color: "white",
            backgroundColor: "transparent",
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </div>
  );
};

const LevelUpRewardsTable = (props) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    props.getRechargeRewards(); // eslint-disable-next-line
  }, []);

  const level = useSelector((state) => state.rechargeReward.rechargeRewards);

  useEffect(() => {
    setData(level);
    console.log("level", level);
  }, [level]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toUpperCase()
      ? e.target.value.trim().toUpperCase()
      : e.target.value.trim();
    if (value) {
      const data = level.filter((data) => {
        return data?.title?.toUpperCase()?.indexOf(value) > -1;
      });
      setData(data);
    } else {
      return setData(level);
    }
  };

  const handleAddReward = (levelId) => {
    dispatch({
      type: OPEN_RECHARGE_REWARD_DIALOG,
      payload: { _id: levelId },
    });
  };

  const handleDelete = (rechargeRewardId, rewardIndex) => {
    const _data = {
      rechargeRewardId,
      rewardIndex,
    };
    const data = warningv2(
      "Delete Reward",
      "Are you sure you want to delete this reward?",
    );
    data
      .then((isDeleted) => {
        if (isDeleted) {
          props.deleteRechargeReward(_data);
          alert("Deleted!", `Reward has been deleted!`, "success");
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Recharge Reward</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Recharge Reward
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header pb-0">
              <div className="row my-3">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left"></div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right mt-3 mt-lg-0 mt-xl-0">
                  <form action="">
                    <div className="input-group mb-3 border rounded-pill">
                      <div className="input-group-prepend border-0">
                        <div id="button-addon4" className="btn text-danger">
                          <i className="fas fa-search mt-2"></i>
                        </div>
                      </div>
                      <input
                        type="search"
                        placeholder="What're you searching for?"
                        aria-describedby="button-addon4"
                        className="form-control bg-none border-0 rounded-pill searchBar"
                        onChange={handleSearch}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="card-body card-overflow">
              <div className="d-sm-flex align-items-center justify-content-between mb-4"></div>

              <table className="table table-striped">
                <thead className="text-white">
                  <tr>
                    {/* <th>No.</th> */}
                    <th> Recharge Diamonds</th>
                    <th> Rewards</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {data.length > 0 ? (
                    (rowsPerPage > 0
                      ? data.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                      : data
                    ).map((data, index) => {
                      return (
                        <tr key={index}>
                          {/* <td>{index + 1}</td> */}
                          <td>{data.diamonds}</td>

                          <td>
                            <div className="d-flex gap-4 align-items-center justify-content-center flex-row">
                              {data.rewards.map((reward, index) => (
                                <LevelRewards
                                  key={index}
                                  data={reward}
                                  handleDelete={() =>
                                    handleDelete(data._id, index)
                                  }
                                />
                              ))}
                              <Tooltip title="Add Reward">
                                <IconButton
                                  onClick={() => handleAddReward(data._id)}
                                  style={{
                                    backgroundColor: "transparent",
                                    color: "rgba(255, 255, 255, 0.7)",
                                    width: "45px",
                                    height: "45px",
                                    borderRadius: "50%",
                                    transition: "all 0.2s ease",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      "rgba(0, 0, 0, 0.3)";
                                    e.currentTarget.style.color = "white";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      "transparent";
                                    e.currentTarget.style.color =
                                      "rgba(255, 255, 255, 0.7)";
                                  }}
                                  size="small"
                                >
                                  <AddIcon />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="7" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <TablePagination
                id="pagination"
                component="div"
                rowsPerPageOptions={[
                  5,
                  10,
                  25,
                  100,
                  { label: "All", value: -1 },
                ]}
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </div>
          </div>
        </div>
      </div>
      <RechargeRewardDialog />
    </>
  );
};

export default connect(null, {
  getRechargeRewards,
  deleteRechargeReward,
})(LevelUpRewardsTable);
